import { Mail, MessageSquare, Send } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function Contact() {
  const [busy, setBusy] = useState(false);
  const onSubmit = (e) => {
    e.preventDefault();
    setBusy(true);
    setTimeout(() => {
      setBusy(false);
      e.target.reset();
      toast.success("Thanks! We'll get back to you within 24h.");
    }, 900);
  };
  return (
    <section id="contact" data-testid="contact-section" className="max-w-4xl mx-auto px-4 py-24">
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <div className="pill"><span>Contact</span></div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl leading-none">
            Talk to a <span className="text-gradient">human.</span>
          </h2>
          <p className="mt-4 text-[var(--fg-muted)]">
            Questions, brand partnerships, or bulk pixel deals — send us a note and we&apos;ll reply within 24 hours.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <div className="flex items-center gap-2"><Mail className="w-4 h-4" /> hello@pixelverse.io</div>
            <div className="flex items-center gap-2"><MessageSquare className="w-4 h-4" /> Live chat weekdays 9–5 PT</div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="glass p-6 space-y-3" data-testid="contact-form">
          <input data-testid="contact-name" required placeholder="Your name" className="input-lux" />
          <input data-testid="contact-email" required type="email" placeholder="Email" className="input-lux" />
          <textarea data-testid="contact-message" required placeholder="How can we help?" rows="5" className="input-lux" />
          <button data-testid="contact-submit" disabled={busy} className="btn-primary w-full">
            <Send className="w-4 h-4" /> {busy ? "Sending…" : "Send message"}
          </button>
        </form>
      </div>
    </section>
  );
}
